import "ngstorage";
import IterableService from "../../services/iterable.js";

class EtamapController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    SecurityService,
    TrackingService,
    $rootScope,
    $scope,
    $location,
    $timeout,
    $window,
    $companies,
    Messagingv2Service,
    EventsService,
    JobsService,
    SocialService,
    IterableService
  ) {
    this.name = "etamap";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$security = SecurityService;
    this.$window = $window;
    this.$location = $location;
    this.$social = SocialService;
    this.$iterable = IterableService;
    this.$timeout = $timeout;
    this.$jobs = JobsService;
    this.setVerificationNoti = false;
    this.$events = EventsService;
    this.currentUser = this.$auth.getUserData();
    this.$scope = $scope;
    this.$tracking = TrackingService;
    this.$messagingv2 = Messagingv2Service;
    this.$companies = $companies;

    var _this = this;

    _this.LoadETADataListener = _this.$rootScope.$on("LoadETAData", function ($event, params) {
      console.log("---------------------LoadETADataLoad---------------------");
      console.log("---------------------LoadETADataLoad---------------------");
      console.log("---------------------LoadETADataLoad---------------------");
      _this.load_eta_data("HELLO");
      console.dir(params);

      _this.event_id = params.event.id;
      _this.index = params.ind;

      /*
	    	_this.load_eta_data(params.event, params.jobble);
	    	*/
    });

    _this.$scope.$on("$destroy", _this.LoadETADataListener);
  }

  load_eta_data(msg) {
    var _this = this;
    console.dir(msg);
    /*
		console.log("load_eta_data");
		console.dir(event_id);
		console.dir(jobble_id);
		_this.$events.load_eta_data(event_id,jobble_id).then(function(response){
			console.log("response");
			console.dir(response);
			_this.handle_eta_response(response);
		},function(error){
			console.log("in error");
			console.dir(response);
		});
		*/
  }

  close() {
    var _this = this;
    console.log("close");
    console.dir(_this.event_id);
    console.dir(_this.index);
    _this.$timeout(function () {
      _this.$rootScope.$emit("CloseEtaModal", {
        eid: _this.event_id,
        index: _this.index,
      });
    });
  }

  handle_eta_response(data) {
    var _this = this;
    console.log("data");
    console.dir(data);
  }
}

EtamapController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "security",
  "tracking",
  "$rootScope",
  "$scope",
  "$location",
  "$timeout",
  "$window",
  "companies",
  "messagingv2",
  "events",
  "jobs",
  "social",
  "iterable",
];

export default EtamapController;



// WEBPACK FOOTER //
// ./client/app/common/etamap/etamap.controller.js